import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ }) => css`
    width: 100%;
    height: calc(100vh - 109px);
    position: relative;

    display: flex;

    .mainDashboard {
      display: flex;
      flex-direction: column;
      flex: 1 1 0%;
    }
  `}
`;
